export default {
    data: () => ({
        windowWidth: window.innerWidth,
    }),
    mounted() {
        window.addEventListener('resize', () => {
            this.windowWidth = window.innerWidth;
        });
    }
};
